import { ReactNode } from 'react'
import { useApplicationContext } from '../../../provider'

interface ExperimentHocPropType {
  children: ReactNode
  experimentName: string
}

export const ExperimentHoc = ({
  children,
  experimentName,
}: ExperimentHocPropType) => {
  const { experiments } = useApplicationContext()

  if (experiments?.[experimentName]) {
    return children
  }

  return null
}

export default ExperimentHoc
